// هیرو صفحه‌ی اصلی: نوار پوستر + تصویر بزرگ + تریلر.
// ۱۲ آیتم اول در HTML می‌آید؛ بقیه فقط وقتی کاربر به آیتم دهم برسد یا نوار را تا انتها اسکرول کند یک‌جا از سرور گرفته می‌شوند.
// سایت راست‌به‌چپ است: «بعدی» یعنی ایندکس بالاتر = سمت چپ صفحه.

// تریلر خودکار و بی‌صدا پخش می‌شود، ولی فقط بعد از لود کامل صفحه (تا با لود صفحه رقابت نکند). هنگام خروج از دید،
// عوض‌کردن اسلاید یا پنهان‌شدن تب، دانلود قطع می‌شود. کلیک روی نشان «تریلر» هم پخش را شروع می‌کند.
const TRAILER_DELAY_MS = 1500;
const SWIPE_MIN_PX = 48;

let controller = null;
let trailerTimer = null;

function hydrate(bg) {
  if (!bg) {
    return;
  }

  bg.querySelectorAll('source[data-srcset]').forEach((source) => {
    source.srcset = source.dataset.srcset;
    source.removeAttribute('data-srcset');
  });

  const img = bg.querySelector('img[data-src]');
  if (img) {
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
  }
}

// تریلر فقط روی دسکتاپِ سریع: موبایل/دیتاسیو/اتصال کند/کاهش حرکت/حالت سبک → فقط تصویر ثابت
function canPlayTrailers() {
  const connection = navigator.connection || {};
  const slow = connection.saveData || /(^|-)(2g|3g)$/.test(connection.effectiveType || '');

  return window.matchMedia('(min-width: 1025px) and (hover: hover)').matches
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    && !document.documentElement.classList.contains('kg-lite')
    && !slow;
}

function initHero(root) {
  const stage = root.querySelector('.hero-showcase__stage');
  const rail = root.querySelector('[data-hero-rail]');
  const panelsBox = root.querySelector('[data-hero-panels]');
  const soundBtn = root.querySelector('[data-hero-sound]');
  const endpoint = root.dataset.endpoint;
  const total = Number(root.dataset.total || 0);
  const prefetchAt = Number(root.dataset.prefetch || 10);
  const trailersAllowed = canPlayTrailers();

  const abort = new AbortController();
  const { signal } = abort;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let current = 0;
  let loaded = Number(root.dataset.loaded || 0);
  let fetching = null;
  let wantSound = false;
  let heroVisible = true;

  const backgrounds = () => [...stage.querySelectorAll('[data-hero-bg]')];
  const tabs = () => [...rail.querySelectorAll('[data-hero-tab]')];
  const panels = () => [...panelsBox.querySelectorAll('[data-hero-info]')];

  // ── تریلر ────────────────────────────────────────────────────
  const stopTrailers = () => {
    clearTimeout(trailerTimer);
    stage.querySelectorAll('video').forEach((video) => {
      video.pause();
      video.classList.remove('is-playing');

      if (video.getAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
    });
    soundBtn.hidden = true;
  };

  const playTrailer = (bg, { manual = false } = {}) => {
    const video = bg?.querySelector('video');
    if (!video) {
      return;
    }

    if (!manual && !trailersAllowed) {
      return;
    }

    if (!video.src) {
      video.src = video.dataset.src;
    }

    video.muted = !wantSound;
    video.addEventListener('playing', () => {
      video.classList.add('is-playing');
      soundBtn.hidden = false;
    }, { once: true });
    video.play().catch(() => {});
  };

  const syncSoundButton = () => {
    soundBtn.setAttribute('aria-pressed', wantSound ? 'true' : 'false');
    soundBtn.classList.toggle('is-on', wantSound);
  };

  soundBtn.addEventListener('click', () => {
    wantSound = !wantSound;
    stage.querySelectorAll('video').forEach((video) => { video.muted = !wantSound; });
    syncSoundButton();
  }, { signal });

  // ── دسته‌های بعدی ─────────────────────────────────────────────
  const fetchMore = () => {
    if (loaded >= total) {
      return Promise.resolve(false);
    }
    if (fetching) {
      return fetching;
    }

    fetching = fetch(`${endpoint}?offset=${loaded}`, { headers: { Accept: 'application/json' }, signal })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error('hero batch failed'))))
      .then((data) => {
        if (!data.count) {
          loaded = total;
          return false;
        }

        const sentinel = rail.querySelector('[data-hero-sentinel]');
        const shade = stage.querySelector('.hero-showcase__shade');
        shade.insertAdjacentHTML('beforebegin', data.backgrounds);
        panelsBox.insertAdjacentHTML('beforeend', data.panels);
        if (sentinel) {
          sentinel.insertAdjacentHTML('beforebegin', data.posters);
        } else {
          rail.insertAdjacentHTML('beforeend', data.posters);
        }

        loaded += data.count;
        if (loaded >= total) {
          sentinel?.remove();
        }

        return true;
      })
      .catch(() => false)
      .finally(() => { fetching = null; });

    return fetching;
  };

  // scrollIntoView کل سکشن (و صفحه) را هم جابه‌جا می‌کرد؛ فقط خود نوار را اسکرول می‌دهیم.
  // اختلاف مرکزها با getBoundingClientRect محاسبه می‌شود تا در RTL هم درست باشد.
  const centerTab = (tab) => {
    const railBox = rail.getBoundingClientRect();
    const tabBox = tab.getBoundingClientRect();
    const delta = (tabBox.left + tabBox.width / 2) - (railBox.left + railBox.width / 2);
    rail.scrollBy({ left: delta, top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  // ── انتخاب اسلاید ────────────────────────────────────────────
  const show = (index, { scroll = true } = {}) => {
    const count = tabs().length;
    current = (index + count) % count;

    const bgs = backgrounds();
    const tabEls = tabs();
    const panelEls = panels();

    hydrate(bgs[current]);
    hydrate(bgs[(current + 1) % count]);

    bgs.forEach((el, i) => el.classList.toggle('is-active', i === current));
    tabEls.forEach((el, i) => {
      el.classList.toggle('is-active', i === current);
      el.setAttribute('aria-selected', i === current ? 'true' : 'false');
    });
    panelEls.forEach((el, i) => {
      const active = i === current;
      el.classList.toggle('is-active', active);
      el.toggleAttribute('inert', !active);
      el.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    if (scroll) {
      centerTab(tabEls[current]);
    }

    stopTrailers();
    trailerTimer = setTimeout(() => playTrailer(bgs[current]), TRAILER_DELAY_MS);

    // به آیتم دهم (۳ تا مانده به انتهای بخشِ لودشده) رسیدیم → بقیه‌ی آیتم‌ها را یک‌جا بگیر
    if (current + 1 >= prefetchAt) {
      fetchMore();
    }
  };

  const step = async (delta) => {
    const next = current + delta;

    if (delta > 0 && next >= tabs().length) {
      // آخرین آیتمِ لودشده: اگر چیزی باقی مانده اول بگیر، وگرنه به اول برگرد
      if (await fetchMore()) {
        show(next);
        return;
      }
      show(0);
      return;
    }

    show(next);
  };

  rail.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-hero-tab]');
    if (tab) {
      show(tabs().indexOf(tab));
    }
  }, { signal });

  panelsBox.addEventListener('click', (event) => {
    if (event.target.closest('[data-hero-trailer]')) {
      stopTrailers();
      playTrailer(backgrounds()[current], { manual: true });
    }
  }, { signal });

  root.querySelector('[data-hero-prev]').addEventListener('click', () => step(-1), { signal });
  root.querySelector('[data-hero-next]').addEventListener('click', () => step(1), { signal });

  // ── کشیدن با ماوس/لمس ────────────────────────────────────────
  // ۱) روی تصویر/اطلاعات: کشیدن افقی = اسلاید بعدی/قبلی
  let startX = 0;
  let startY = 0;
  let tracking = false;

  root.addEventListener('pointerdown', (event) => {
    if (event.button > 0 || event.target.closest('[data-hero-rail], a, button')) {
      return;
    }
    tracking = true;
    startX = event.clientX;
    startY = event.clientY;
  }, { signal });

  window.addEventListener('pointerup', (event) => {
    if (!tracking) {
      return;
    }
    tracking = false;

    const dx = event.clientX - startX;
    const dy = event.clientY - startY;

    if (Math.abs(dx) >= SWIPE_MIN_PX && Math.abs(dx) > Math.abs(dy) * 1.4) {
      // راست‌به‌چپ: کشیدن به راست = آیتم بعدی (که سمت چپ است)
      step(dx > 0 ? 1 : -1);
    }
  }, { signal });

  root.addEventListener('pointercancel', () => { tracking = false; }, { signal });
  // درگ بومیِ تصویرها pointer eventها را قطع می‌کند
  root.addEventListener('dragstart', (event) => event.preventDefault(), { signal });

  // ۲) روی نوار پوستر: ماوس مثل لمس نوار را درگ می‌کند (لمس خودش اسکرول بومی دارد)
  let dragging = false;
  let moved = false;
  let dragStartX = 0;
  let dragStartScroll = 0;

  rail.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) {
      return;
    }
    dragging = true;
    moved = false;
    dragStartX = event.clientX;
    dragStartScroll = rail.scrollLeft;
  }, { signal });

  window.addEventListener('pointermove', (event) => {
    if (!dragging) {
      return;
    }
    const dx = event.clientX - dragStartX;
    if (!moved && Math.abs(dx) > 5) {
      moved = true;
      rail.classList.add('is-dragging');
    }
    if (moved) {
      rail.scrollLeft = dragStartScroll - dx;
    }
  }, { signal });

  window.addEventListener('pointerup', () => {
    if (!dragging) {
      return;
    }
    dragging = false;
    rail.classList.remove('is-dragging');
  }, { signal });

  // بعد از درگ، کلیکِ پایان‌دهنده روی پوستر نباید اسلاید را عوض کند
  rail.addEventListener('click', (event) => {
    if (moved) {
      event.stopPropagation();
      event.preventDefault();
      moved = false;
    }
  }, { capture: true, signal });

  // ── کیبورد: سایت راست‌به‌چپ است؛ ← بعدی (سمت چپ)، → قبلی (سمت راست) ──────────────
  // فقط وقتی هیرو روی صفحه دیده می‌شود و کاربر داخل فیلد متنی/منو نیست.
  document.addEventListener('keydown', (event) => {
    if (!heroVisible || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }

    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    const target = event.target;
    if (target instanceof HTMLElement && (target.isContentEditable || target.closest('input, textarea, select, [role="dialog"], [role="menu"]'))) {
      return;
    }

    event.preventDefault();
    step(event.key === 'ArrowLeft' ? 1 : -1);
  }, { signal });

  // ── کاربر نوار را تا نزدیک انتها اسکرول کرد → دسته‌ی بعدی (نه قبل از آن) ─────────
  rail.addEventListener('scroll', () => {
    const remaining = rail.scrollWidth - Math.abs(rail.scrollLeft) - rail.clientWidth;
    if (remaining < 320) {
      fetchMore();
    }
  }, { passive: true, signal });

  // بعد از لود صفحه تصویر اسلاید بعدی آماده شود و تریلر اسلاید اول شروع شود
  const warm = () => {
    hydrate(backgrounds()[1]);
    trailerTimer = setTimeout(() => playTrailer(backgrounds()[current]), TRAILER_DELAY_MS);
  };

  if (document.readyState === 'complete') {
    warm();
  } else {
    window.addEventListener('load', warm, { once: true, signal });
  }

  if ('IntersectionObserver' in window) {
    const visibility = new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;

      if (!entry.isIntersecting) {
        stopTrailers();
      } else if (!document.hidden && !stage.querySelector('video.is-playing')) {
        clearTimeout(trailerTimer);
        trailerTimer = setTimeout(() => playTrailer(backgrounds()[current]), TRAILER_DELAY_MS);
      }
    }, { threshold: 0.35 });

    visibility.observe(root);
    signal.addEventListener('abort', () => visibility.disconnect());
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopTrailers();
    } else {
      trailerTimer = setTimeout(() => playTrailer(backgrounds()[current]), TRAILER_DELAY_MS);
    }
  }, { signal });

  signal.addEventListener('abort', stopTrailers);
  syncSoundButton();
  controller = abort;
}

export function destroyHomeHero() {
  clearTimeout(trailerTimer);
  controller?.abort();
  controller = null;
}

export function bootHomeHero() {
  destroyHomeHero();
  const root = document.querySelector('[data-hero-showcase]');
  if (root) {
    initHero(root);
  }
}
